// Angular
import { Injectable } from '@angular/core';

// XLXS
import * as FileSaver from 'file-saver';
import * as XLXS from 'xlsx';

declare var getDate: any;

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8';
const EXCEL_EXT = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExporterService {

  constructor() { }

  exportToExcel(json: any[], excelFileName: string): void {
    const header = Object.keys(json[0]); // columns name
    var wscols = [];
    for (var i = 0; i < header.length; i++) {  // columns length added
      wscols.push({ wch: header[i].length + 25 })
    }

    const worksheet: XLXS.WorkSheet = XLXS.utils.json_to_sheet(json);
    worksheet["!cols"] = wscols;
    const workbook: XLXS.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data']
    };
    const excelBuffer: any = XLXS.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcel(excelBuffer, excelFileName);
  }

  private saveAsExcel(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    const date = (new Date(Date.now()).toLocaleString()).replace(",", "_").replace(" ", "");

    FileSaver.saveAs(data, fileName.concat("_".concat(String(date))).concat(EXCEL_EXT));
  }

}
